import(/* webpackMode: "eager", webpackExports: ["PaydirtSidebar"] */ "/workspace/web/domains/paydirt/layout/PaydirtSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginLink"] */ "/workspace/web/platform/auth/LoginLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DiscoveryRightRail"] */ "/workspace/web/platform/calendar/CalendarSidebarWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalPageNav"] */ "/workspace/web/platform/legal/LegalPageNav.tsx");
